"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var useMercadopago = function (publicKey, options) {
    var _a = react_1.useState(), mercadopago = _a[0], setMercadopago = _a[1];
    react_1.useEffect(function () {
        var script = document.createElement('script');
        script.src = 'https://sdk.mercadopago.com/js/v2';
        script.addEventListener('load', function () {
            setMercadopago(new window.MercadoPago(publicKey, options));
        });
        document.body.appendChild(script);
        return function () {
            var iframe = document.querySelector('iframe');
            if (iframe) {
                document.body.removeChild(iframe);
            }
            document.body.removeChild(script);
        };
    }, []);
    return mercadopago;
};
exports.default = useMercadopago;
//# sourceMappingURL=v2.js.map